<div class="sidebar-backdrop" (mousedown)="close()">
  <div
    class="stacked-sidebar"
    [ngStyle]="{
      width: baseService.isMobile || fullWidth ? '100vw' : width,
      'max-width': baseService.isMobile ? '100vw' : maxWidth,
    }"
    (mousedown)="$event.stopPropagation()"
    [@slideInOut]="sidebarState"
    (@slideInOut.done)="onAnimationDone($event)"
  >
    @if (!baseService.isMobile && !fullWidth) {
      <div
        [cdkTrapFocus]="true"
        (keydown.escape)="close()"
        class="sidebar-close transition-[top] duration-200"
        [style.top]="'calc(5% + ' + stackOffset * 48 + 'px)'"
        (click)="close()"
      >
        <app-icon>close</app-icon>
      </div>
    }

    @switch (type) {
      @case (SidebarType.Planner) {
        <app-planner-v2 [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.BuyOlxAdsBundles) {
        <app-buy-olx-ads-bundles [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.AdvertAction) {
        <app-advert-action [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.BuyOlxPackages) {
        <app-buy-olx-packages-v2 [payload]="payload" (close)="close($event)" />
      }

      @case (SidebarType.CardV3) {
        <app-board-v3-card-detail
          #cardV3Detail
          [cardId]="$safeNavigationMigration(payload?.card_id)"
          [entityType]="$safeNavigationMigration(payload?.type)"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.BoardV3CardViewSettings) {
        <app-board-v3-card-view-settings
          [funnelId]="payload?.funnelId ?? null"
          [activeKeys]="payload?.activeKeys ?? []"
          (apply)="close({ viewFields: $event })"
          (close)="close($event)"
        />
      }
      @case (SidebarType.BoardV3QuickCreateSettings) {
        <app-board-v3-quick-create-settings
          [funnelId]="payload?.funnelId ?? null"
          [activeKeys]="payload?.activeKeys ?? []"
          [managers]="payload?.managers ?? []"
          (apply)="close({ createFields: $event })"
          (close)="close($event)"
        />
      }
      @case (SidebarType.BoardV3SectionFields) {
        <app-board-v3-section-fields-dialog
          [funnelId]="payload?.funnelId ?? null"
          [activeColumns]="payload?.activeColumns ?? []"
          (apply)="close({ columns: $event })"
          (closeChange)="close()"
        />
      }
      @case (SidebarType.BoardV3FieldsSettings) {
        <app-board-v3-fields-settings
          [funnelId]="payload?.funnelId ?? null"
          [funnelCurrency]="payload?.funnelCurrency ?? 'UAH'"
          [entityType]="payload?.entityType ?? ''"
          (apply)="onBoardV3FieldsChanged($event)"
          (closeChange)="closeWithCurrentResult()"
        />
      }
      @case (SidebarType.BoardV3StageSettings) {
        <app-board-v3-stage-settings
          [funnelId]="payload?.funnelId ?? null"
          [columns]="payload?.columns ?? []"
          (close)="close($event)"
        />
      }
      @case (SidebarType.BoardV3Filters) {
        <app-board-v3-filters
          [entityMode]="payload?.entityMode ?? 'card'"
          [funnelId]="payload?.funnelId ?? null"
          [funnelType]="payload?.funnelType ?? ''"
          [fields]="payload?.fields ?? []"
          [managers]="payload?.managers ?? []"
          [activeData]="payload?.activeData"
          [activeFilterId]="payload?.activeFilterId ?? null"
          (apply)="close({ filters: $event.data, filterName: $event.name, filterId: $event.filterId })"
          (closeChange)="close()"
        />
      }
      @case (SidebarType.BoardV3ImportMapping) {
        <app-board-v3-import-mapping
          [funnelId]="payload?.funnelId ?? null"
          [fields]="payload?.fields ?? []"
          [columns]="payload?.columns ?? []"
          (close)="close($event)"
        />
      }
      @case (SidebarType.BoardV3ExportFields) {
        <app-board-v3-export-fields
          [funnelId]="payload?.funnelId ?? null"
          [fields]="payload?.fields ?? []"
          (close)="close($event)"
        />
      }
      @case (SidebarType.BoardV3MoveCard) {
        <app-board-v3-move-card
          [card]="payload?.card ?? null"
          [cards]="payload?.cards ?? []"
          [columns]="payload?.columns ?? []"
          (close)="close($event)"
        />
      }
      @case (SidebarType.BoardV3LeadConversion) {
        <app-board-v3-lead-conversion
          [cardIds]="payload?.cardIds ?? []"
          (close)="close($event)"
        />
      }
      @case (SidebarType.BoardV3MergeCards) {
        <app-board-v3-merge-cards [cardIds]="payload?.cardIds ?? []" (close)="close($event)" />
      }
      @case (SidebarType.BoardV3LinkChat) {
        <app-board-v3-link-chat [excludes]="payload?.excludes ?? []" (close)="close($event)" />
      }
      @case (SidebarType.BoardV3ContactForm) {
        <app-board-v3-contact-form [cardIds]="payload?.cardIds ?? []" (close)="close($event)" />
      }
      @case (SidebarType.BoardV3LinkContact) {
        <app-board-v3-link-contact [excludes]="payload?.excludes ?? []" (close)="close($event)" />
      }
      @case (SidebarType.BoardV3ContactDetail) {
        <app-board-v3-contact-detail
          #contactDetail
          [contactId]="payload?.contactId ?? null"
          [canOpenCards]="payload?.canOpenCards ?? true"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.BoardV3CompanyForm) {
        <app-board-v3-company-form [cardIds]="payload?.cardIds ?? []" (close)="close($event)" />
      }
      @case (SidebarType.BoardV3CompanyDetail) {
        <app-board-v3-company-detail
          #companyDetail
          [companyV2Id]="payload?.companyV2Id ?? null"
          [canOpenCards]="payload?.canOpenCards ?? true"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.WarehouseProductForm) {
        <app-warehouse-product-form
          #closeGuard
          [productId]="payload?.productId ?? null"
          [categoryId]="payload?.categoryId ?? null"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.WarehouseProductImport) {
        <app-warehouse-product-import #closeGuard (close)="close($event, true)" />
      }
      @case (SidebarType.WarehouseForm) {
        <app-warehouse-form [warehouse]="payload?.warehouse ?? null" (close)="close($event)" />
      }
      @case (SidebarType.WarehouseDocument) {
        <app-warehouse-document-detail
          #closeGuard
          [documentId]="payload?.documentId ?? null"
          [type]="payload?.type ?? 'RECEIPT'"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.BoardV3WarehouseSettings) {
        <app-board-v3-warehouse-settings [funnelId]="payload?.funnelId ?? null" (close)="close($event)" />
      }
      @case (SidebarType.BoardV3PaymentForm) {
        <app-payment-form
          [cardId]="payload?.cardId"
          [defaultAmount]="payload?.defaultAmount ?? null"
          [currency]="payload?.currency ?? null"
          [payment]="payload?.payment ?? null"
          [confirmOnly]="payload?.confirmOnly ?? false"
          [chats]="payload?.chats ?? []"
          (close)="close($event)"
        />
      }
      @case (SidebarType.PaymentServiceForm) {
        <app-payment-service-form [service]="payload?.service ?? null" (close)="close($event)" />
      }
      @case (SidebarType.VchasnoKasaHistory) {
        <app-fiscal-history
          [registerId]="payload?.registerId"
          [registerName]="payload?.registerName ?? ''"
          [shiftId]="payload?.shiftId ?? null"
          (close)="close()"
        />
      }
      @case (SidebarType.VchasnoKasaReturn) {
        <app-fiscal-return
          #closeGuard
          [payment]="payload?.payment"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.VchasnoKasaOperationDetail) {
        <app-fiscal-operation-detail
          #closeGuard
          [operationId]="payload?.operationId"
          [registerName]="payload?.registerName ?? ''"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.VchasnoKasaRegisterForm) {
        <app-cash-register-form #closeGuard [register]="payload?.register ?? null" (close)="close($event, true)" />
      }
      @case (SidebarType.VchasnoKasaSettings) {
        <app-prro [configuration]="true" (close)="close()" />
      }
      @case (SidebarType.NovaPoshtaSettings) {
        <app-nova-poshta-settings (close)="close($event)" />
      }
      @case (SidebarType.NovaPoshtaShipmentForm) {
        <app-nova-poshta-shipment-form [cardId]="payload?.cardId" [prefill]="payload?.prefill ?? null" (close)="close($event)" />
      }
      @case (SidebarType.NovaPoshtaLinkForm) {
        <app-nova-poshta-link-form [cardId]="payload?.cardId" (close)="close($event)" />
      }
      @case (SidebarType.TaskForm) {
        <app-task-form
          #closeGuard
          [links]="payload?.links ?? []"
          [deadline]="payload?.deadline ?? null"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.TaskDetail) {
        <app-task-detail
          #closeGuard
          [taskId]="payload?.taskId ?? null"
          [canOpenCards]="payload?.canOpenCards ?? true"
          (close)="close($event, true)"
        />
      }
      @case (SidebarType.BoardV3CallTranscript) {
        <app-board-v3-call-transcript [callId]="payload?.callId ?? null" (close)="close($event)" />
      }
      @case (SidebarType.ChatTimeline) {
        <app-chat-timeline [chatId]="payload?.chatId" [chatTitle]="payload?.chatTitle" (close)="close($event)" />
      }
      @case (SidebarType.BoardV3CreateFunnel) {
        <app-board-v3-create-funnel
          [funnel]="payload?.funnel ?? null"
          [funnelType]="payload?.funnelType"
          [dealFunnels]="payload?.dealFunnels ?? []"
          (close)="close($event)"
        />
      }
      @case (SidebarType.AutomationLogDetails) {
        <app-automation-log-details [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.Chats) {
        <app-chats-sidebar [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.Contact) {
        <app-contact-detail [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.CreateGroup) {
        <app-create-group [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.EmployeeProfile) {
        <app-employee-profile [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.InviteEmployees) {
        <app-invite-employees (close)="close($event)" />
      }
      @case (SidebarType.InviteManager) {
        <app-invite-manager [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.Ticket) {
        <app-ticket [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.UpdateManager) {
        <app-update-manager [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.ChannelTypes) {
        <app-channel-types [payload]="payload ?? {}" (close)="close($event)" />
      }
      @case (SidebarType.ChannelGroupForm) {
        <app-channel-group-form #closeGuard [group]="payload?.group ?? null" (close)="close($event, true)" />
      }
      @case (SidebarType.CreateChannel) {
        <app-create-channel [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.Site) {
        <app-create-site [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.Order) {
        <app-create-order-site [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.CardLegacy) {
        <app-card-details [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.CreateAds) {
        <app-create-ads [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.ChangeAdvert) {
        <app-create-update-olx-advert [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.BuyOlxPackageLegacy) {
        <app-buy-olx-package [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationCheckbox) {
        <app-integration-checkbox [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationAi) {
        <app-integration-ai [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.NeuronAndAnotherCrm) {
        <app-neuron-and-another-crm [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationRingostat) {
        <app-integration-ringostat [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationOlx) {
        <app-integration-olx [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationRia) {
        <app-integration-ria [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationTelegramBot) {
        <app-integration-telegram-bot [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationTelegramUser) {
        <app-integration-telegram-user [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.CreateWidget) {
        <app-create-widget [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationInstagram) {
        <app-integration-instagram [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationFacebook) {
        <app-integration-facebook [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationViber) {
        <app-integration-viber [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationWhatsapp) {
        <app-integration-whatsapp [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationProm) {
        <app-integration-prom [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationTiktok) {
        <app-integration-tiktok [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationTelegram) {
        <app-integration-telegram [payload]="payload" (close)="close($event)" />
      }
      @case (SidebarType.IntegrationRingostatChannel) {
        <app-integration-ringostat-channel [payload]="payload" (close)="close($event)" />
      }
    }
  </div>
</div>
